import ScrollTo from './ScrollTo';

export default ScrollTo;



// WEBPACK FOOTER //
// ./src/components/scroll-to/index.js